import { takeLatest } from "redux-saga/effects";
import {
	getAssetLocationHistoryListSuccess,
	getAssetLocationHistoryListFail,
	getAssetLocationHistoryDetailsSuccess,
	getAssetLocationHistoryDetailsFail,
} from "./assetLocationHistoryState";
import createCrudService from "../../services/crudservice";

import {
	doCrudCall,
	LOADING_MSG,
} from "../../utils/crudSagaHelper";

const crudService = createCrudService(
	"api/v1/system/asset-location-history"
);

function* getAssetLocationHistoryList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload),
		getAssetLocationHistoryListSuccess,
		getAssetLocationHistoryListFail,
		null,
		null,
		LOADING_MSG
	);
}

function* getAssetLocationHistoryDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload),
		getAssetLocationHistoryDetailsSuccess,
		getAssetLocationHistoryDetailsFail,
		null,
		null,
		LOADING_MSG
	);
}

function* assetLocationHistorySaga() {
	yield takeLatest("assetLocationHistory/getAssetLocationHistoryList",getAssetLocationHistoryList);
	yield takeLatest("assetLocationHistory/getAssetLocationHistoryDetails",getAssetLocationHistoryDetails);
}

export default assetLocationHistorySaga;